<template>
  <div class="page-width-warpper">
    <div class="searchInfo" v-show="!!queryParams.title">
      已筛选标题：<el-tag closable @close="clearSearch">{{
        queryParams.title
      }}</el-tag>
    </div>
    <div class="news-warpper">
      <div style="flex: 1">
        <ul class="list" v-if="list && list.length > 0">
          <li v-for="(item, i) in list" :key="i" @click="toDetail(item)">
            <!-- <div style="overflow: hidden; margin-right: 25px">
              <img class="image" :src="item.icon" />
            </div> -->
            <div class="info">
              <div>
                <div class="title">
                  <p>
                    {{ item.title }}
                  </p>
                </div>
                <!-- <div class="text">
                  {{ item.summary }}
                </div> -->
              </div>
              <span
                >时间：{{ item.createTime }} 点击：{{ item.cmsViewNum }}次</span
              >
            </div>
          </li>
        </ul>
        <!-- 添加暂无内容提示 -->
        <div v-else class="no-data">
          暂无内容
        </div>
        <div style="margin: 0 auto; max-width: 600px">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from "@/assets/images/banner/news.jpg";
import { pageByCode } from "@/api/index";

export default {
  name: "Search",
  data() {
    return {
      banner,
      list: [],
      hotList: [],
      categories: [],
      active: "",
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        title: undefined,
      },
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.queryParams.title = val.query.title || "";
        this.getList();
      },
    },
  },
  created() {
    // this.getList();
  },
  methods: {
    clearSearch() {
      //this.$router.replace(`/`);
      this.$router.push('/')
    },
    getList() {
      const params = {
        ...this.queryParams,
      };
      pageByCode(params).then((res) => {
        this.list = res.data && res.data.records;
        if (this.queryParams.pageNum === 1) {
          this.hotList = this.list;
        }
        this.total = res.data.total || 0;
      });
    },
    toDetail(item) {
      this.$router.push(`/searchDetail?id=${item.id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.searchInfo {
  padding-top: 15px;
}

.no-data {
  text-align: center;
  padding: 50px 0;
  color: #999;
  font-size: 16px;
}

.news-warpper {
  display: flex;
  padding-bottom: 12px;
  .list {
    margin-top: 20px;
    border: 1px solid #eee;
    li {
      display: flex;
      cursor: pointer;
      padding: 10px 15px;
      // border-bottom: 1px solid #eee;
      background: #f2f2f2;
      &:nth-child(2n + 1) {
        background: #fff;
      }
      &:hover {
        .image {
          transform: scale(1.2);
        }
        .title {
          P {
            text-decoration: underline;
          }
        }
      }
      .image {
        width: 196px;
        height: 130px;
        object-fit: cover;
        border-radius: 2px;
        transition: 0.5s all;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 30px;
      }
      .title {
        display: flex;
        line-height: 30px;
        p {
          font-size: 16px;
          color: $main-color;
          flex: 1;
          @include clamp(2);
        }
      }
      .text {
        display: none;
        // margin-top: 10px;
        line-height: 1.6;
        font-size: 14px;
        color: #666;
        @include clamp(3);
      }
      span {
        margin-top: 5px;
        font-size: 12px;
        color: #999;
      }
    }
  }
}
</style>
